module.exports = __webpack_public_path__ + "img/電気回路_4_4.f6ab5aa4.png";